import React from 'react';
import './AIModal.css';

function AIModal({ isOpen, onClose, children }) {
  if (!isOpen) return null;

  return (
    <div className={`ai-modal-overlay ${isOpen ? 'open' : ''}`}>
      <div className="ai-modal-content">
        {children}
      </div>
    </div>
  );
}

export default AIModal;
